<template>
  <div>
    <!-- 编辑随访 -->
    <a-modal
      :visible="visible"
      :title="title"
      :centered="true"
      @ok="handleOk"
      @cancel="handleCancel"
      :destroyOnClose="true"
    >
      <div class="z-flex handle-stage handle-stage-num">
        <div class="_label">阶段：</div>
        <div class="_input" v-if="remindTitle">{{ remindTitle }}</div>
        <div v-else class="_input num">
          第
          <a-input
            v-bind:value="editInfo.flowNum"
            @input="handleInput"
            min="1"
            type="number"
            style="width: 88px"
            :disabled="!eidtNum"
          />
          次疗效跟踪
          <span class="tips" v-show="showNumTips">请输入疗效跟踪次数</span>
        </div>
      </div>
      <div class="z-flex handle-stage">
        <div class="_label">时间：</div>
        <div class="_input">
          <a-date-picker
            v-model:value="editInfo.followDate"
            format="YYYY-MM-DD"
            :disabled="!editTime"
            :disabled-date="disabledDate"
            style="width: 200px"
            placeholder="请输入推送时间"
            @change="handleChange"
          />
          <span class="tips" v-show="showTips">请输入推送时间</span>
        </div>
      </div>
      <div class="z-flex handle-stage" v-if="showResult">
        <div class="_label">结果：</div>
        <a-radio-group :options="flowResultStatusList" v-model:value="editInfo.flowResultStatus" />
      </div>
    </a-modal>
  </div>
</template>
<script setup>
import { reactive, defineProps, defineEmits, watch, ref } from 'vue'
import { flowResultStatusList } from '../hooks/config'
import { get } from 'lodash'
import moment from 'moment'

const props = defineProps({
  currentStageInfo: {
    type: Object,
    required: false,
    default: () => {}
  },
  visible: {
    type: Boolean,
    required: true,
    default: false
  },
  followupPlanId: {
    // 随访计划id
    type: [String, Number],
    required: false,
    default: undefined
  },
  nextFlowNum: {
    // 增加随访阶段的时候默认递增
    type: String,
    required: false,
    default: ''
  }
})
watch(
  () => props.visible,
  () => {
    init()
  }
)
const title = ref('添加')
const eidtNum = ref(false) // 可编辑次数
const editTime = ref(false) // 可编辑推送时间
const showResult = ref(false) // 可编辑结果
const showTips = ref(false)
const showNumTips = ref(false)
const remindTitle = ref('') // 复诊提醒名称
const editInfo = reactive({
  flowNum: null,
  followDate: null,
  flowResultStatus: null,
  flowId: null,
  followupPlanId: null, //新增随访阶段的时候需要传,
  flowType: 2
})
const emits = defineEmits(['update:visible', 'editStage'])
function handleOk() {
  showTips.value = !editInfo.followDate
  showNumTips.value = editInfo.flowType === 2 ? !editInfo.flowNum : false
  if (showTips.value || showNumTips.value) return
  emits('editStage', editInfo)
  emits('update:visible', false)
}
function handleCancel() {
  showTips.value = false
  showNumTips.value = false
  emits('update:visible', false)
}
function handleChange(val) {
  showTips.value = !val
}
function handleInput(e) {
  const val = e.target.value
  editInfo.flowNum = val.replace(/\D/g, '').replace(/^0/g, '')
  if (editInfo.flowNum > 99) editInfo.flowNum = 99
  showNumTips.value = false
}
function init() {
  const date = get(props, 'currentStageInfo.followDate', null)
  editInfo.flowResultStatus = get(props, 'currentStageInfo.flowResultStatus', null)
  editInfo.followDate = date ? moment(date).format('YYYY-MM-DD') : null
  editInfo.flowId = get(props, 'currentStageInfo.id', null)
  editInfo.followupPlanId = props.followupPlanId
  editInfo.flowType = get(props, 'currentStageInfo.flowType', 2)
  initStatus()
}
const initStatus = () => {
  let status = ''
  const stageName = get(props, 'currentStageInfo.stageName', '')
  // 提取疗效跟踪次数
  try {
    // FIX：初始化null值缓存
    remindTitle.value = null
    const flowNum = stageName ? stageName : props.nextFlowNum
    const reg = /第(.*)次疗效跟踪/
    const res = reg.exec(flowNum)
    // 复诊提醒阶段title不可修改 2 为疗效跟踪，3为复诊提醒跟踪
    if (editInfo.flowType == 2) {
      editInfo.flowNum = res ? res[1] : null
    } else {
      console.log('111', 111)
      editInfo.flowNum = null
      remindTitle.value = stageName
    }
  } catch {
    editInfo.flowNum = null
  }

  if (props.followupPlanId) {
    status = 'add'
    editInfo.flowNum = editInfo.flowNum >= 99 ? editInfo.flowNum : ++editInfo.flowNum
  } else {
    const { pushStatusCode } = props.currentStageInfo
    status = [1, 3].includes(pushStatusCode) ? 'editResult' : 'edit'
  }
  switch (status) {
    case 'add':
      title.value = '添加'
      eidtNum.value = true
      editTime.value = true
      showResult.value = false
      break
    case 'edit':
      title.value = ''
      // title.value = '待推送'
      eidtNum.value = true // 待推送状态时，支持阶段的次数编辑
      editTime.value = true
      showResult.value = true // 已推送更改为可编辑
      break
    case 'editResult':
      title.value = ''
      // title.value = '已推送'
      eidtNum.value = false
      editTime.value = false
      showResult.value = true
      break
  }
}
const disabledDate = current => {
  return current && current < moment().endOf('day')
}
// const disabledDate = current => {
//   return current && current < moment().subtract(1, 'days').endOf('day')
// }
</script>
<style scoped lang="scss">
.handle-stage {
  justify-content: flex-start;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  margin-bottom: 16px;
  &.handle-stage-num {
    margin-bottom: 22px;
  }
  ._label {
    color: #666666;
    padding-right: 8px;
    text-align: left;
  }
  ._input {
    position: relative;
    &.num {
      display: flex;
      flex-direction: row;
      align-items: center;
      .ant-input {
        margin: 0 5px;
      }
    }
    .tips {
      color: #f5222d;
      position: absolute;
      bottom: -22px;
      left: 0;
      font-size: 12px;
    }
  }
}
</style>
